// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__cd-MF","pink":"About_pink__wfDVD","green":"About_green__Ijgok","skills":"About_skills__rMEXU"};